import { useMemo, useState } from "react";
import {
  diasEntre,
  textoRelacaoContrato,
  textoRelacaoLimite,
  textosJustificativa,
  validarJustificativaCondicoes,
} from "../../../../hooks/nova-obra.condicoes";
import { rotuloTipoPorCodigo } from "../../../../hooks/nova-obra.tipos";
import { formatDataBr } from "../../../format-data";
import type { JustificativaCondicoesDialogProps } from "./types-justificativa-condicoes-dialog";

export function useJustificativaCondicoesDialog({
  condicoes,
  periodo,
  hoje,
  catalogo,
  justificativaInicial = "",
  onJustificar,
  onAjustarDatas,
  onAdicionarTipo,
  onClose,
}: JustificativaCondicoesDialogProps) {
  const [justificativa, setJustificativa] = useState(justificativaInicial);
  const [tentou, setTentou] = useState(false);
  const rotulo = (codigo: string) => rotuloTipoPorCodigo(catalogo, codigo);
  const textos = useMemo(
    () =>
      textosJustificativa(condicoes, periodo, hoje, formatDataBr, (c) =>
        rotuloTipoPorCodigo(catalogo, c),
      ),
    [condicoes, periodo, hoje, catalogo],
  );
  const erro = validarJustificativaCondicoes(justificativa);
  const mostrarErro = tentou && erro !== null;
  const { limites, contrato } = condicoes;
  const [limiteUnico] = limites;
  const tabela = limites.length > 1;
  const variante = tabela ? "larga" : limiteUnico && contrato ? "combinada" : "simples";
  const alterarJustificativa = (texto: string) => setJustificativa(texto);
  const confirmar = () => {
    // RN22/AC19: vazia (ou só espaços) não fecha a modal e o campo mostra o erro.
    if (erro) {
      setTentou(true);
      return;
    }
    onJustificar(justificativa.trim());
  };

  return {
    justificativa,
    alterarJustificativa,
    textos,
    erro,
    mostrarErro,
    limites,
    contrato,
    limiteUnico,
    tabela,
    variante,
    confirmar,
    periodo,
    hoje,
    onAjustarDatas,
    onAdicionarTipo,
    onClose,
    diasDaObra: diasEntre(periodo.inicio, periodo.fim) + 1,
    relacaoLimiteUnico: limiteUnico ? textoRelacaoLimite(limiteUnico, periodo, hoje) : null,
    relacaoContrato: contrato ? textoRelacaoContrato(contrato.terminoContrato, periodo) : null,
    linhasLimites: limites.map((limite) => ({
      vistoria: limite.vistoria,
      descricao: limite.descricao,
      dataLimite: limite.dataLimite,
      critico: limite.relacao !== "DURANTE_A_OBRA",
      relacao: textoRelacaoLimite(limite, periodo, hoje),
      renovaCom: limite.renovaCom ? rotulo(limite.renovaCom) : null,
    })),
  };
}
